import React from 'react';
import { Link } from 'react-router-dom';

const ComoFunciona: React.FC = () => {
  const steps = [
    {
      icon: '📝',
      title: 'Crie sua Conta',
      description: 'Cadastre-se gratuitamente em poucos minutos. Você pode ser comprador, vendedor ou ambos.',
    },
    {
      icon: '🔍',
      title: 'Busque ou Anuncie',
      description: 'Encontre o animal ideal usando nossos filtros avançados ou crie seu anúncio com fotos e vídeos.',
    },
    {
      icon: '💬',
      title: 'Negocie com Segurança',
      description: 'Use nosso chat integrado para conversar diretamente com compradores ou vendedores.',
    },
    {
      icon: '✅',
      title: 'Feche o Negócio',
      description: 'Combine os detalhes da transação e finalize sua compra ou venda com tranquilidade.',
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <div className="bg-gradient-to-br from-green-700 to-green-900 text-white py-16">
        <div className="container-custom text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Como Funciona</h1>
          <p className="text-xl text-green-100 max-w-2xl mx-auto">
            Comprar ou vender na BOILX é simples, rápido e seguro.
          </p>
        </div>
      </div>

      {/* Steps */}
      <div className="container-custom py-16">
        <div className="max-w-4xl mx-auto">
          <div className="space-y-8">
            {steps.map((step, index) => (
              <div key={index} className="flex gap-6 items-start">
                <div className="flex-shrink-0 w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center text-3xl">
                  {step.icon}
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-sm font-bold text-green-700 bg-green-100 px-2 py-1 rounded">
                      Passo {index + 1}
                    </span>
                    <h3 className="text-xl font-bold text-gray-900">{step.title}</h3>
                  </div>
                  <p className="text-gray-600">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* For Buyers */}
        <div className="max-w-4xl mx-auto mt-16">
          <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">Para Compradores</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-xl shadow-sm text-center">
              <div className="text-4xl mb-4">🔎</div>
              <h3 className="font-semibold mb-2">Busca Inteligente</h3>
              <p className="text-gray-600 text-sm">Filtros por raça, idade, localização, preço e muito mais.</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm text-center">
              <div className="text-4xl mb-4">📸</div>
              <h3 className="font-semibold mb-2">Fotos e Vídeos</h3>
              <p className="text-gray-600 text-sm">Veja detalhes do animal antes de entrar em contato.</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm text-center">
              <div className="text-4xl mb-4">⭐</div>
              <h3 className="font-semibold mb-2">Avaliações</h3>
              <p className="text-gray-600 text-sm">Confira a reputação do vendedor antes de negociar.</p>
            </div>
          </div>
        </div>

        {/* For Sellers */}
        <div className="max-w-4xl mx-auto mt-16">
          <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">Para Vendedores</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-xl shadow-sm text-center">
              <div className="text-4xl mb-4">📢</div>
              <h3 className="font-semibold mb-2">Alcance Nacional</h3>
              <p className="text-gray-600 text-sm">Seu anúncio visível para compradores de todo o Brasil.</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm text-center">
              <div className="text-4xl mb-4">🚀</div>
              <h3 className="font-semibold mb-2">Destaque Premium</h3>
              <p className="text-gray-600 text-sm">Aumente a visibilidade com planos de destaque.</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm text-center">
              <div className="text-4xl mb-4">📊</div>
              <h3 className="font-semibold mb-2">Estatísticas</h3>
              <p className="text-gray-600 text-sm">Acompanhe visualizações e interesse nos seus anúncios.</p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="max-w-4xl mx-auto mt-16 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Pronto para Começar?</h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/registrar"
              className="px-8 py-3 bg-green-700 text-white rounded-lg font-semibold hover:bg-green-800 transition-colors"
            >
              Criar Conta Grátis
            </Link>
            <Link
              to="/planos"
              className="px-8 py-3 border-2 border-green-700 text-green-700 rounded-lg font-semibold hover:bg-green-50 transition-colors"
            >
              Ver Planos
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComoFunciona;
